import React from "react";

export const TaskGroupsConfig = {
    settings: {
        layout: {
            config: {
                rightSidePanel: {
                    display: false 
                }
            }
        }
    },
    routes: [
        {
            path: "/maintenance-management/operation-groups",
            component: React.lazy(() => import("./TaskGroups"))
        },
       
    ]
};